// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.img {
  width: 100%;
  max-width: 280px;
  min-width: 150px;
  margin-bottom: 40px;
}

.resend-a {
  color: #0063cf !important;
  cursor: pointer;
  text-decoration: none;
}

.check img {
  width: 125px;
  height: 125px;
}

.text-dark-grey {
  color: #757C8A !important;
}

.zikata-token-sent {
  height: 100vh;
  padding-top: 80px;
}`, "",{"version":3,"sources":["webpack://./libs/auth/src/lib/components/token-sent/token-sent.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,yBAAA;EACA,eAAA;EACA,qBAAA;AACF;;AAGE;EACE,YAAA;EACA,aAAA;AAAJ;;AAIA;EACI,yBAAA;AADJ;;AAIA;EACE,aAAA;EACA,iBAAA;AADF","sourcesContent":[".img {\n  width: 100%;\n  max-width: 280px;\n  min-width: 150px;\n  margin-bottom: 40px;\n}\n\n.resend-a {\n  color: #0063cf !important;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.check {\n  img {\n    width: 125px;\n    height: 125px;\n  }\n}\n\n.text-dark-grey {\n    color: #757C8A !important;\n}\n\n.zikata-token-sent {\n  height: 100vh;\n  padding-top: 80px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
